/* eslint-disable max-len */
import React, { PropTypes, PureComponent } from 'react';
import FeedsSelectorAuthPill from './FeedsSelectorAuthPill';

const isStreamStatus = (status, type) => (
    typeof status === 'string' &&
    status.trim() !== '' &&
    typeof type === 'string' &&
    type.trim() !== '' &&
    status.trim().toLowerCase() === type.trim().toLowerCase()
);

const getDisplayTimeMetaData = ({ status, duration, time }) => {
    let displayTime = null;
    let displayClass = '';
    const STATUS_TYPES = {
        LIVE: 'live',
        UPCOMING: 'upcoming',
        REPLAY: 'replay'
    };


    if (isStreamStatus(status, STATUS_TYPES.LIVE)) {
        displayTime = STATUS_TYPES.LIVE.toUpperCase();
        displayClass = STATUS_TYPES.LIVE;
    } else if (isStreamStatus(status, STATUS_TYPES.UPCOMING)) {
        displayTime = `${time}`;
    } else if (isStreamStatus(status, STATUS_TYPES.REPLAY)) {
        displayTime = duration;
    }

    return {
        displayTime,
        displayClass
    };
};

const findMatchingStreamById = (streamId, streamsList = []) => {
    let matchingStream;

    if (Array.isArray(streamsList) && streamsList.length > 0 && streamId) {
        streamsList.some(elem => {
            if (Array.isArray(elem.contents) && elem.contents.length > 0) {
                matchingStream = elem.contents.filter(stream =>
                    typeof stream.id === 'string' && stream.id === streamId
                )[0];
            }

            if (matchingStream) {
                return true;
            }

            return false;
        });
    }

    return matchingStream;
};

class FeedsSelector extends PureComponent {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    onClick(event) {
        console.log('Feeds Selector onClick triggered:', this.props, streamId); // eslint-disable-line
        const streamId = event.currentTarget.getAttribute('data-id');
        const { feeds } = this.props;
        const selectedStream = findMatchingStreamById(streamId, feeds);
        if (selectedStream && !selectedStream.selected && !selectedStream.blackoutText) {
            this.props.onClick(selectedStream.streams[0]);
            this.props.onClose();
        } else {
            console.warn('Will not play stream, current stream matches selected stream');
        }
    }

    closeModal() {
        this.props.onClose();
    }

    render() {
        const { title, feeds, userAuth } = this.props;

        const feedItems = feeds.length > 0 && feeds.map(({ name, contents }) => {
            let feedEntries = null;

            if (Array.isArray(contents) && contents.length > 0) {
                feedEntries = contents.map(({
                    id,
                    imageHref,
                    name: streamName,
                    subtitle,
                    status,
                    duration,
                    time,
                    playbackErrorMessage,
                    selected,
                    authTypes = [],
                    packages = []
                }) => {
                    const timeMeta = getDisplayTimeMetaData({ status, duration, time });
                    const selectedClass = selected ? 'selected' : '';

                    return (
                        <div className={`StreamingCard ${selectedClass}`} data-id={id} onClick={this.onClick}>
                            <div className="StreamingCard__MediaWrapper">
                                { imageHref &&
                                    <img
                                        src={imageHref}
                                        alt={streamName}
                                    />
                                }
                                <div className={`StreamingCard__Media__Play ${timeMeta.displayClass}`} />
                                <div className={`StreamingCard__Media__Pill ${timeMeta.displayClass}`}>
                                    {timeMeta.displayTime}
                                </div>
                                {selected && (
                                    <div className="StreamingCard__NowPlaying">
                                        Now Playing
                                    </div>
                                )}
                            </div>

                            <div className="StreamingCard__ContentWrapper">
                                <div className="StreamingCard__Content">
                                    <h4>{streamName}</h4>
                                    <ul className="StreamingCard__Meta">
                                        <li>{subtitle}</li>
                                    </ul>
                                    {playbackErrorMessage && (
                                        <div className="StreamingCard__Error">
                                            {playbackErrorMessage}
                                        </div>
                                    )}
                                </div>
                                {
                                    !playbackErrorMessage && (
                                        <FeedsSelectorAuthPill
                                            streamContent={{ authTypes, packages, id, streamName }}
                                            userAuth={userAuth}
                                        />
                                    )
                                }
                            </div>

                        </div>
                    );
                });
            }

            return (
                <div className="StreamPicker__Row">
                    <div className="StreamPicker__Broadcast">{name}</div>
                    {feedEntries}
                </div>
            );
        });

        return (
            <div className="video-overlays-container">
                <div className="overlay streampicker">
                    <div id="stream-view" className="video-player__stream js-video-player__stream">
                        <div className="StreamPicker__Container">
                            <div className="StreamPicker__Header">
                                <h1>{title}</h1>
                                <div className="StreamPicker__Close" onClick={this.closeModal} />
                            </div>
                            <div className="StreamPicker__Body">
                                {feedItems}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

FeedsSelector.propTypes = {
    title: PropTypes.string,
    feeds: PropTypes.array,
    userAuth: PropTypes.array,
    onClick: PropTypes.func,
    onClose: PropTypes.func
};

FeedsSelector.defaultProps = {
    feeds: [],
    userAuth: []
};

export default FeedsSelector;



// WEBPACK FOOTER //
// ./app/webapp/player/FeedsSelector.js